import { Users, Bus, Briefcase, CalendarCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";

const CARDS = [
  { id: "coinvolgimento", Icon: Users, title: "Coinvolgimento", text: "Modulati per gli studenti di qualsiasi anno, per una strategia lungo tutto il percorso." },
  { id: "logistica", Icon: Bus, title: "Logistica", text: "Trasferiamo l'opportunità, la scuola organizza il trasporto con la totale autonomia e i propri vettori convenzionati." },
  { id: "workshop", Icon: Briefcase, title: "Workshop", text: "Vere esperienze ad alto valore formativo focalizzate sui reali ruoli aziendali, non semplici 'tour'." },
  { id: "gratuita", Icon: CalendarCheck, title: "Gratuità e Prenotazione", text: "Piattaforma 100% gratuita, visualizza le date e prenota con un modulo rapido." },
];

export const Esperienze = () => (
  <section className="relative px-6 py-20 lg:py-36" data-testid="istituti-esperienze-section">
    <div className="max-w-7xl mx-auto">
      <Reveal className="text-center mb-14 lg:mb-20">
        <Eyebrow className="mb-6">Esperienze sul Campo</Eyebrow>
        <h2 className="mx-auto max-w-[20ch] font-extrabold tracking-[-0.04em] leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
          Workshop e visite aziendali con un click
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 lg:gap-6">
        {CARDS.map(({ id, Icon, title, text }, i) => (
          <Reveal key={id} delay={i * 100} className="h-full">
            <article className="why-card glass glass-light h-full rounded-[24px] p-8" data-testid={`esperienza-card-${id}`}>
              <Icon className="h-6 w-6 text-cyan" strokeWidth={1.4} />
              <h3 className="mt-8 font-bold tracking-[-0.02em] text-xl">{title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-titanium">{text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
